export default __webpack_public_path__ + "static/media/QLD_Accepted.531c755c.png";